import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SignInPage } from '@zehnmindai/embed/react';
import baseAxios from '@/shared/utils/request';
import { AUTH_SIGN_IN } from '@/shared/utils/urls';
import { DocsLogo } from '@/shared/ui/DocsLogo.jsx';

// ─────────────────────────────────────────────────────────────
// Nobody is signed in (the SessionProvider already tried one silent sign-in
// at zehn-id): @zehnmindai/embed's sign-in page. "Continue with zehn-id"
// goes to docs' BFF (/bff/login) and back to this page. The install's
// break-glass admin's username and password form shows only while docs-api
// offers it (`GET /api/v1/auth/sign-in` → `{password: true}`,
// ZEHN_PASSWORD_LOGIN); it sets docs-api's HttpOnly admin cookie.
//
// Guest signers (E-IMZO, no zehn-id account) never come here: their pages
// (a guest link, the verification page) sign them in with their certificate.
//
// The page's layout is the SDK's; its look is the app's (the `zehn-sign-in*`
// rules in index.css).
// ─────────────────────────────────────────────────────────────

export function SignIn() {
  const { t } = useTranslation('common');
  const [passwordLogin, setPasswordLogin] = useState(false);

  useEffect(() => {
    let cancelled = false;
    baseAxios
      .get(AUTH_SIGN_IN)
      .then(({ data }) => {
        if (!cancelled) setPasswordLogin(data?.password === true);
      })
      // No answer: zehn-id only. The page still works.
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const labels = useMemo(() => {
    const text = t('signIn.page', { returnObjects: true });
    return text && typeof text === 'object' ? text : undefined;
  }, [t]);

  return (
    <SignInPage passwordLogin={passwordLogin} labels={labels}>
      <div className="flex justify-center mb-2">
        <DocsLogo />
      </div>
    </SignInPage>
  );
}

export default SignIn;
